export const enum Integrations {
    Outreach = 'Outreach',
    Salesforce = 'Salesforce',
    Hubspot = 'Hubspot',
}

export enum IntegrationsContactTypes {
  Outreach = 'OUTREACH',
  Salesforce = 'SALESFORCE',
  Hubspot = 'HUBSPOT',
}

export const enum IntegrationCodes {
    Outreach = 'OR',
    Salesforce = 'SF',
    Hubspot = 'HS',
    HubspotCustom = 'HSC'
}

export const enum IntegrationMappingModalModes {
    Edit = 'edit',
    Create = 'create',
    Delete = 'delete'
}